import {ParkPlanningAnalyticsScheduleQuery, ProcessDetailScheduleQuery} from '../../graphql';
import { take } from 'rxjs/operators';
import { PlaningEventCategoryColorPipe } from '../../../pipes/planing-event-category-color/planing-event-category-color.pipe';
import {TClassBlockColorPipe} from '../../../pipes/tclass-block-color/tclass-block-color.pipe';
import {Pipe, PipeTransform} from '@angular/core';

export class KpiAnalyticsScheduleModel {
  plannedEvents: IKpiAnalyticsSchedule[];
  realEvents: IKpiAnalyticsSchedule[];

  public static mapParkSchedule(data: ParkPlanningAnalyticsScheduleQuery, eventColorPipe: PlaningEventCategoryColorPipe): KpiAnalyticsScheduleModel {
    if (data && data.PARKS.length > 0) {
      const turbines = data.PARKS.flatMap(p => p.TURBINES);
      const logbookData  = this.groupByBlock(data.PARKS[0].DATA.TABLE.DATA_LGB.logbook_monthly);
      return new KpiAnalyticsScheduleModel({
        plannedEvents: data.PARKS[0].DATA.TABLE.DATA_PLN.planned_events.map((event: any) =>
          KpiAnalyticsScheduleModel.mapTorKpiAnalyticsSchedule(event, eventColorPipe, turbines, EKpiAnalyticsScheduleType.PLANNED)),
        realEvents: logbookData.sort((a, b) => a.startTs - b.startTs).filter(l => !!l.category).map(logbook =>
          KpiAnalyticsScheduleModel.mapTorKpiAnalyticsSchedule(logbook, eventColorPipe, turbines, EKpiAnalyticsScheduleType.REAL)
        )
      });
    } else {
      return new KpiAnalyticsScheduleModel({
        plannedEvents: [],
        realEvents: []
      });
    }
  }

  public static mapProcessSchedule(data: ProcessDetailScheduleQuery, eventColorPipe: PlaningEventCategoryColorPipe, tclassBlocksColorPipe: TClassBlockColorPipe): KpiAnalyticsScheduleModel {
    if (data && data.PORTFOLIO) {
      const turbines = data.TURBINES;
      const logbookData = this.groupByBlock(data.PORTFOLIO.DATA.TABLE.DATA_LGB.logbook_monthly);
      return new KpiAnalyticsScheduleModel({
        plannedEvents: data.PORTFOLIO.DATA.TABLE.DATA_PLN.planned_events.map((event: any) =>
            KpiAnalyticsScheduleModel.mapTorKpiAnalyticsSchedule(event, eventColorPipe, turbines, EKpiAnalyticsScheduleType.PLANNED)),
        realEvents: logbookData.sort((a, b) => a.startTs - b.startTs).map(logbook =>
            KpiAnalyticsScheduleModel.mapTorKpiAnalyticsSchedule(logbook, tclassBlocksColorPipe, turbines, EKpiAnalyticsScheduleType.REAL, 'tcu')
        )
      });
    } else {
      return new KpiAnalyticsScheduleModel({
        plannedEvents: [],
        realEvents: []
      });
    }
  }

  private static groupByBlock(data) {
    const groupedBlocksById = [];
    const blocksIDs = [...new Set(data.map(item => item.turbineId))];
    for (const id of blocksIDs) {
      const blocks = data.filter(b => b.turbineId === id).sort((a, b) => a.startTs - b.startTs);
      groupedBlocksById.push(...blocks);
    }
    return groupedBlocksById;
  }

  private static mapTorKpiAnalyticsSchedule(event: any, colorPipe: PipeTransform, turbines: any[], type: EKpiAnalyticsScheduleType, colorProperty = 'category'): IKpiAnalyticsSchedule {
    let color = '';
    colorPipe.transform(event[colorProperty]).pipe(
      take(1)
    ).subscribe((result: string) => color = result);
    const currentTurbine = turbines.find(t => t.id === event.turbineId);
    return {
      category: event.category,
      tcu: event.tcu,
      endTs: event.endTs,
      assetId: event.turbineId,
      assetName: currentTurbine ? currentTurbine.code.replaceAll('_', ' ') : '-',
      startTs: event.startTs,
      color,
      type
    };
  }

  constructor(init: Partial<KpiAnalyticsScheduleModel>) {
    Object.assign(this, init);
  }
}

export interface IKpiAnalyticsSchedule {
  category: string;
  tcu: string;
  color: string;
  startTs: number;
  endTs: number;
  assetId: string;
  assetName: string;
  type: EKpiAnalyticsScheduleType;
}

export enum EKpiAnalyticsScheduleType {
  PLANNED = 'PLANNED',
  REAL = 'REAL'
}
